import Icon from "@ant-design/icons";

const SecuritySvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M4188 5110 c-239 -41 -456 -209 -558 -434 -48 -105 -63 -180 -64
   -306 0 -139 17 -210 78 -335 76 -153 190 -267 340 -340 104 -50 160 -63 194
   -44 28 15 38 45 28 84 -5 19 -24 30 -92 56 -213 80 -357 248 -400 464 -40 206
   32 417 194 565 232 213 587 211 820 -5 111 -104 173 -228 192 -385 9 -73 17
   -99 32 -112 39 -35 93 -17 112 36 11 32 -14 184 -45 270 -122 338 -477 545
   -831 486z"
      />
      <path
        d="M1835 5014 c-81 -13 -707 -178 -752 -199 -103 -47 -177 -126 -213
   -227 -10 -31 -39 -220 -69 -458 -29 -223 -54 -415 -56 -426 -4 -17 -17 -25
   -55 -34 -119 -29 -201 -128 -200 -244 2 -160 153 -270 318 -232 31 7 32 6 32
   -23 0 -26 -4 -31 -25 -31 -46 0 -133 -41 -175 -81 -76 -74 -111 -186 -91 -294
   26 -138 118 -265 236 -326 l63 -33 6 -63 c14 -135 82 -316 169 -451 86 -133
   258 -292 390 -362 26 -14 47 -27 47 -30 0 -4 -56 -25 -124 -49 -68 -23 -140
   -53 -159 -66 -47 -33 -77 -97 -77 -167 l0 -55 -85 -56 c-90 -60 -105 -66 -105
   -42 0 25 -36 88 -67 117 -46 44 -99 61 -210 66 l-103 5 0 344 c0 380 1 374
   -64 431 -86 75 -200 61 -272 -34 l-29 -37 -3 -363 -3 -362 -30 -12 c-42 -18
   -104 -92 -118 -142 -9 -31 -11 -166 -9 -479 l3 -436 30 -49 c19 -30 49 -60 79
   -79 l49 -30 427 -3 c421 -3 427 -3 453 18 20 16 27 31 27 55 0 50 -37 75 -111
   75 l-58 0 10 32 c5 18 9 179 9 358 l0 325 122 80 c67 44 125 81 128 82 3 2 23
   -30 44 -70 75 -140 121 -177 216 -177 63 0 100 15 168 69 30 24 55 41 57 39 2
   -2 24 -55 48 -117 l44 -114 -74 -226 c-40 -124 -76 -238 -79 -253 l-6 -28
   -130 0 c-71 0 -137 -4 -147 -10 -10 -5 -24 -22 -30 -39 -10 -24 -10 -34 3 -59
   8 -16 23 -32 31 -36 9 -3 484 -6 1055 -6 l1039 0 27 24 28 23 -13 164 c-7 90
   -18 230 -26 310 -23 241 -23 242 -360 464 l-263 174 -4 69 c-3 55 -9 77 -31
   109 -34 49 -72 70 -214 118 -62 21 -113 41 -113 44 1 3 42 31 92 61 119 71
   266 214 342 331 91 140 154 311 172 460 6 54 7 55 60 83 151 79 245 229 245
   391 0 79 -10 120 -41 170 -47 76 -155 145 -227 145 -19 0 -23 5 -23 30 0 30 1
   31 38 23 93 -18 180 6 239 67 49 51 67 96 67 170 0 115 -64 197 -181 235 l-68
   22 -20 156 c-16 118 -25 161 -39 176 -27 30 -76 28 -106 -4 -23 -25 -23 -25
   -11 -137 7 -62 15 -124 18 -137 5 -20 3 -23 -12 -17 -35 13 -291 57 -449 76
   -509 62 -1057 41 -1548 -60 -49 -9 -88 -15 -88 -13 0 50 106 797 116 822 17
   41 76 106 114 126 27 14 618 168 715 186 107 20 199 7 520 -75 382 -98 398
   -103 446 -144 59 -51 80 -100 100 -242 16 -112 21 -127 45 -148 20 -17 34 -22
   53 -17 66 16 71 45 46 225 -25 175 -101 291 -230 351 -33 15 -213 67 -400 115
   -311 79 -350 87 -450 89 -60 2 -123 1 -140 -1z m338 -1334 c312 -16 575 -54
   880 -127 174 -41 202 -58 202 -121 0 -46 -31 -87 -71 -95 -13 -2 -93 13 -177
   33 -356 88 -662 123 -1057 123 -284 0 -579 -21 -623 -44 -43 -23 -43 -98 -1
   -126 21 -14 39 -14 181 1 424 42 816 27 1231 -49 75 -14 145 -28 155 -31 15
   -5 17 -19 17 -109 0 -100 1 -104 26 -124 21 -16 41 -21 93 -21 115 0 171 -55
   171 -167 0 -50 -6 -73 -32 -124 -39 -75 -82 -111 -174 -148 -59 -24 -71 -32
   -81 -62 -7 -19 -12 -55 -12 -80 -1 -67 -43 -224 -84 -311 -96 -208 -258 -369
   -471 -468 -44 -21 -100 -43 -123 -49 -52 -14 -83 -51 -83 -99 0 -97 -88 -182
   -187 -182 -107 0 -176 62 -195 174 -6 36 -18 72 -27 79 -9 8 -45 24 -81 36
   -88 31 -218 100 -288 155 -67 51 -157 145 -203 212 -84 123 -149 309 -165 471
   -8 84 -22 102 -101 127 -112 37 -196 153 -197 273 -1 69 16 101 74 141 26 17
   47 22 102 22 60 0 72 3 93 25 23 22 25 31 25 124 l0 100 40 11 c69 18 91 80
   45 125 -31 32 -42 31 -188 -6 -159 -40 -184 -40 -219 0 -37 41 -37 84 0 120
   23 23 54 34 177 64 302 73 569 112 860 126 223 12 253 12 468 1z m-1793 -2100
   l0 -330 -35 0 -35 0 0 330 c0 301 1 330 17 339 11 6 24 6 35 0 17 -9 18 -34
   18 -339z m1264 -245 c17 -33 49 -74 82 -103 l54 -49 -161 -126 c-152 -120
   -186 -139 -215 -119 -20 14 -154 261 -154 285 0 14 7 30 15 37 12 10 317 123
   346 129 4 0 19 -24 33 -54z m984 -71 c12 -8 22 -24 22 -36 0 -22 -119 -247
   -148 -280 -30 -35 -58 -21 -221 108 l-160 125 58 57 c31 31 67 78 80 104 l22
   47 162 -55 c89 -31 172 -62 185 -70z m-589 -209 l81 -66 -15 -37 c-8 -20 -30
   -75 -48 -122 l-33 -85 -74 -3 -75 -3 -48 126 c-27 70 -47 128 -45 129 100 80
   161 126 168 126 4 0 44 -29 89 -65z m-1324 30 c21 -8 39 -25 45 -40 6 -16 10
   -187 10 -431 l0 -406 -29 -29 -29 -29 -246 0 c-260 0 -285 4 -305 47 -7 16
   -11 154 -11 432 0 395 1 409 20 434 11 14 30 28 43 30 12 2 122 5 245 6 174 1
   230 -2 257 -14z m2250 -213 c238 -155 279 -189 294 -236 5 -17 17 -123 26
   -236 9 -113 18 -215 21 -227 l4 -23 -498 0 -498 0 -82 254 -81 254 40 102 c56
   145 47 138 105 92 81 -64 109 -75 179 -70 92 6 128 33 194 151 32 56 59 93 65
   90 6 -4 110 -72 231 -151z m-950 -293 c4 -6 38 -105 75 -220 l67 -209 -207 0
   -208 0 32 103 c18 56 50 155 70 220 l38 117 63 0 c35 0 67 -5 70 -11z"
      />
      <path
        d="M1451 3074 c-30 -38 -26 -62 14 -100 l35 -33 0 -108 c0 -131 10 -153
   70 -153 30 0 43 6 60 27 20 26 21 36 18 191 -3 158 -4 164 -27 183 -17 14 -39
   19 -86 19 -57 0 -66 -3 -84 -26z"
      />
      <path
        d="M2275 3075 c-24 -24 -25 -28 -25 -184 0 -152 1 -161 23 -185 32 -36
   74 -39 107 -6 18 18 20 33 20 140 0 94 3 120 13 120 24 0 47 35 47 72 0 52
   -24 68 -99 68 -52 0 -66 -4 -86 -25z"
      />
      <path
        d="M823 2882 c-27 -4 -53 -38 -53 -68 0 -12 14 -48 30 -79 17 -31 30
   -65 30 -74 0 -44 78 -71 116 -41 28 24 34 55 20 106 -29 109 -81 166 -143 156z"
      />
      <path
        d="M3024 2875 c-33 -13 -75 -83 -94 -154 -14 -55 0 -94 40 -111 47 -19
   81 4 103 69 10 30 27 66 37 82 50 69 -9 147 -86 114z"
      />
      <path
        d="M1630 2307 c-55 -28 -52 -109 5 -133 151 -63 579 -51 652 18 45 42
   17 120 -43 121 -16 0 -69 -7 -118 -16 -137 -26 -296 -20 -446 17 -14 3 -36 0
   -50 -7z"
      />
      <path
        d="M254 960 c-26 -10 -54 -48 -54 -71 0 -9 9 -28 21 -43 l20 -26 218 0
   c206 0 219 1 236 20 25 28 23 76 -4 103 -21 21 -30 22 -219 24 -108 1 -207 -2
   -218 -7z"
      />
      <path
        d="M238 735 c-37 -20 -47 -69 -20 -104 l19 -26 215 -3 c197 -2 217 -1
   238 16 34 27 32 78 -4 109 -26 22 -32 23 -224 23 -152 -1 -203 -4 -224 -15z"
      />
      <path
        d="M2384 615 c-25 -25 -25 -25 -22 -191 3 -160 4 -166 27 -185 22 -18
   43 -19 336 -19 301 0 313 1 339 21 l26 20 0 168 c0 232 37 211 -364 211 l-317
   0 -25 -25z m556 -185 l0 -60 -215 0 -215 0 0 60 0 60 215 0 215 0 0 -60z"
      />
      <path
        d="M4262 4827 c-21 -22 -22 -32 -22 -205 l0 -182 -103 0 c-113 0 -128
   -7 -142 -62 -6 -22 -1 -33 23 -58 l30 -30 137 0 c141 0 185 10 199 45 3 9 6
   117 6 239 0 211 -1 225 -21 250 -27 34 -77 36 -107 3z"
      />
      <path
        d="M1833 4746 c-106 -34 -203 -127 -241 -228 -59 -158 -23 -310 100
   -423 188 -174 487 -118 600 113 31 63 33 73 33 172 0 95 -3 110 -28 163 -37
   74 -110 148 -184 183 -48 23 -74 28 -148 31 -57 2 -105 -2 -132 -11z m212
   -155 c50 -22 109 -86 125 -136 7 -20 10 -65 8 -101 -5 -78 -40 -134 -113 -179
   -41 -26 -58 -30 -114 -30 -200 1 -308 220 -186 378 59 78 189 110 280 68z"
      />
      <path
        d="M4370 4249 c-56 -25 -77 -44 -102 -92 -38 -76 -17 -137 47 -137 35 0
   48 11 74 63 22 45 63 57 99 30 56 -41 43 -74 -113 -287 -57 -79 -107 -154
   -110 -168 -5 -18 0 -33 18 -54 l25 -29 165 0 c148 0 167 2 186 19 26 24 28 77
   3 99 -13 12 -42 17 -104 19 l-87 3 78 112 c111 158 132 231 92 319 -32 70
   -118 124 -197 124 -16 0 -49 -10 -74 -21z"
      />
      <path
        d="M4911 4248 c-13 -7 -37 -29 -52 -48 -48 -59 -219 -373 -219 -401 0
   -51 30 -64 156 -67 l114 -4 0 -58 c0 -51 3 -61 26 -79 35 -27 59 -26 89 4 21
   20 25 34 25 80 0 50 2 56 25 65 55 21 58 103 5 123 l-29 11 -3 163 c-3 158 -4
   163 -28 188 -31 30 -77 40 -109 23z m-1 -308 l0 -70 -40 0 c-22 0 -40 2 -40 5
   0 7 73 135 77 135 2 0 3 -31 3 -70z"
      />
    </g>
  </svg>
);

const SecurityIcon = (props) => <Icon component={SecuritySvg} {...props} />;

export default SecurityIcon;
